import { fromJS } from "immutable"
import * as agents from "../actions/agents"
import { callFinished, callStarted } from "../actions/calls"
import { setDestroy, setICEServers, setSIPCredentials, setSIPServers, setSoftphoneAuth } from "../actions/softphone"
import * as actions from "../actions/websocket"
import config from "../config"

const heartbeatTimeout = 25 * 1000
const slowPingThreshold = 1000
const slowPingLimit = 5

const socketMiddleware = (function () {
    var socket = null
    var disconnecting = false
    var subscribers = []
    var queue = {}
    var timeout
    var interval
    var slowPings = 0
    var version
    var apiKey

    function start(store) {
        interval = setInterval(() => {
            let now = new Date().getTime()

            if (store && timeout && now > timeout) {
                socket.close()
                store.dispatch(actions.disconnect())
            }

            let exp = now - 15000
            for (let id in queue) {
                if (id < exp) {
                    if (queue[id].reject) {
                        //queue[id].reject("Expired")
                    }
                    delete queue[id]
                }
            }
        }, 1000)
    }

    function stop() {
        if (interval) {
            clearInterval(interval)
            interval = null
        }
    }

    let prevStatus = null
    let pageReloaded = true
    const broadcastStatus = status => {
        if (status === prevStatus) return
        for (let callback of subscribers) {
            if (callback && callback[1]) {
                callback[1](status)
            }
        }
        prevStatus = status
    }

    const onOpen = (ws, store) => evt => {
        timeout = new Date().getTime() + heartbeatTimeout

        if (pageReloaded) {
            store.dispatch(actions.send("hangup", ""))
            pageReloaded = false
        }

        start(store)
        broadcastStatus(true)
        send({ cmd: "time", data: new Date() })
        if (version) {
            send({ cmd: "version", data: version })
        }

        store.dispatch(actions.connected())
    }

    const onClose = store => evt => {
        timeout = null
        stop()
        broadcastStatus(false)
        store.dispatch(actions.disconnected())
    }

    const onMessage = (ws, store) => evt => {
        var msg = JSON.parse(evt.data)

        for (let callback of subscribers) {
            if (callback && callback[0]) {
                callback[0](ws, msg.cmd, msg.data)
            }
        }

        if (msg.cmd === "contact") {
            store.dispatch(agents.setContact(fromJS(msg.data)))
        }

        if (msg.cmd === "sipServers") {
            store.dispatch(setSIPServers(msg.data))
        }

        if (msg.cmd === "iceServers") {
            store.dispatch(setICEServers(msg.data))
        }

        if (msg.cmd === "sip_credentials") {
            store.dispatch(setSIPCredentials(msg.data))
            store.dispatch(setSoftphoneAuth(true))
        }

        if (msg.cmd === "ping") {
            timeout = new Date().getTime() + heartbeatTimeout
            send({ cmd: "pong", data: msg.data })
        }

        if (msg.cmd === "call") {
            store.dispatch(callStarted(msg.data))
        }

        if (msg.cmd === "callfinished") {
            store.dispatch(callFinished())
        }

        if (msg.cmd === "hangup") {
            store.dispatch(callFinished())
        }
    }

    const send = data => {
        try {
            if (data.cmd !== "pong") {
                console.log("[wssend]", data)
            }
            socket.send(JSON.stringify(data))
        } catch (e) {
            console.log(e)
        }
    }

    return store => next => action => {
        switch (action.type) {
            case "AGENT_CONTACT_GET":
                send({ cmd: "get_contact", data: action.data })
                break

            case "AGENT_CONTACT_CREATE_OR_UPDATE":
                send({ cmd: "contact_create_or_update", data: action.data })
                break

            case "SEND":
                let id = new Date().getTime()
                queue[id] = {
                    resolve: action.resolve,
                    reject: action.reject,
                }
                send({ cmd: action.cmd, data: action.data, qid: id })
                break

            case "SUBSCRIBE":
                subscribers.push([action.messageCallback, action.statusCallback])
                if (action.statusCallback) {
                    action.statusCallback(prevStatus)
                }
                break

            case "UNSUBSCRIBE":
                for (let i in subscribers) {
                    let pair = subscribers[i]
                    if (pair[0] === action.messageCallback) {
                        delete subscribers[i]
                    }
                }
                break

            case "CONNECT":
                disconnecting = false
                if (socket != null) {
                    socket.close()
                }

                store.dispatch(actions.connecting())
                apiKey = action.apiKey
                const agentSocketURL = config.wsEndpoint + "agentsocket?apikey=" + apiKey
                socket = new WebSocket(agentSocketURL)
                socket.onmessage = onMessage(socket, store)
                socket.addEventListener("close", onClose(store))
                socket.onopen = onOpen(socket, store)
                socket.onerror = (a, b, c) => {
                    for (let callback of subscribers) {
                        if (callback && callback[0]) {
                            callback[0](socket, "error", "Connection failed. Is the API KEY valid?")
                        }
                    }
                }

                break

            case "SOCKETS_DISCONNECTED":
                if (!disconnecting) {
                    setTimeout(() => {
                        store.dispatch(actions.connect(apiKey))
                    }, 1000)
                } else {
                    store.dispatch(setDestroy(false))
                }
                next(action)
                break

            case "SOCKETS_DISCONNECT":
            case "DISCONNECT":
                disconnecting = true
                if (socket != null) {
                    socket.onclose = () => {
                        socket = null
                    }
                    socket.close()
                }
                store.dispatch(actions.disconnected())
                break
            default:
                return next(action)
        }
    }
})()

export default socketMiddleware
